interface AppContext {
  commitHash?: string
  isProduction?: boolean

  /**
   * For lambda widgets, we pass down the inital render props for the React hydration process.
   */
  hydrateProps?: any

  // For debugging
  apolloLink?: any
  apolloCache?: any
  apolloClient?: any
}

let testContext: AppContext | undefined

export function appContext(): AppContext {
  if (testContext != null) {
    return testContext
  }
  if (typeof window !== 'undefined') {
    return (window as any).dynasty || {}
  }
  return {}
}

export function setTestContext(context: AppContext) {
  testContext = context
}
